import { connect } from 'react-redux';
import PaginationComponent from "./PaginationComponent";
import { fetchGetDepartments, getTotalPagesForDepartments, getCurrentPageForDepartments } from "../../../reducers/organization/departments";

const mapStateToProps = state => {
    return {
        current: getCurrentPageForDepartments(state),
        total: getTotalPagesForDepartments(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getDataForPage: (page) => {
            dispatch(fetchGetDepartments(page));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PaginationComponent);



// WEBPACK FOOTER //
// ./src/components/commonComponents/paginationComponent/PaginationDepartments.container.js